<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'FACILITY.FACILITIES_LIST' | translate"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddFacility">
          <button mat-raised-button class="btn btn-primary" (click)="addFacility()">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'FACILITY.ADD_FACILITY' | translate }}</span>
          </button>
        </ng-template>
        <button
          mat-raised-button
          matTooltip="Export as CSV"
          class="btn btn-icon btn-primary ml-2"
          (click)="exportFacilitiesAsCSV($event)"
        >
          <i class="fas fa-download"></i>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 140px !important"
          class="btn btn-sm btn-light-{{ getItemCssClassByStatus(searchIsActiveSelect) }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(searchIsActiveSelect) }} Facilities
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="facilityCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FACILITY.CODE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let facility">{{ facility.facility_code }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCode">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FACILITY.FACILITY_CODE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchCodeInput"
                [placeholder]="'FACILITY.FACILITY_CODE' | translate"
              />
              <button
                *ngIf="searchCodeInput"
                matSuffix
                mat-icon-button
                (click)="searchCodeInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="profile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell
            *matCellDef="let facility"
            class="profile-pic gl-block clickable justify-content-center"
            (click)="showFacilityPhoto(facility)"
          >
            <kt-user-photo
              [create]="'false'"
              [size]="30"
              [type]="'object'"
              [editable]="false"
              [user$]="{ profileUrl: facility.pre_signed_url?.url }"
            >
            </kt-user-photo>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchProfile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FACILITY.FACILITY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let facility" class="flex-column align-items-start">
            <span
              [matTooltip]="canViewFacility() ? 'View Facility' : null"
              [class.clickable]="canViewFacility()"
              (click)="viewFacilityDblclick(facility.id, facility)"
              >{{ facility.name }}</span
            >
            <a href="mailto:{{ facility.email }}">{{ facility.email }}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchNameEmail">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FACILITY.NAME_EMAIL' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchNameEmailInput"
                [placeholder]="'FACILITY.NAME_EMAIL' | translate"
              />
              <button
                *ngIf="searchNameEmailInput"
                matSuffix
                mat-icon-button
                (click)="searchNameEmailInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="facilityType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FACILITY.TYPE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let facility">{{ facility.facility_type }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchType">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchFacilityTypeAutocomplete
              [label]="'FACILITY.FACILITY_TYPE' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getFacilityTypeAutocomplete"
              [optionFormatter]="formatFacilityTypeOption"
              [valueFormatter]="formatFacilityTypeOption"
              [control]="searchFacilityTypeAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="city">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FACILITY.CITY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let facility">{{ facility.city }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCity">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FACILITY.CITY' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchCityInput"
                [placeholder]="'FACILITY.CITY' | translate"
              />
              <button
                *ngIf="searchCityInput"
                matSuffix
                mat-icon-button
                (click)="searchCityInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FACILITY.PHONE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let facility">{{ facility.phone | phoneFormat }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchPhone">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FACILITY.FACILITY_PHONE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchPhoneInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'FACILITY.FACILITY_PHONE' | translate"
              />
              <button
                *ngIf="searchPhoneInput"
                matSuffix
                mat-icon-button
                (click)="searchPhoneInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="contact">
          <mat-header-cell *matHeaderCellDef>{{ 'FACILITY.CONTACTS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let facility" class="d-flex flex-center">
            <ng-container *ngIf="filterContact(facility) as facilities">
              <div *ngIf="facilities?.length >= 1" class="symbol-group symbol-hover flex-center">
                <div
                  [matTooltip]="
                    getTip(facilities[0].contact.first_name, facilities[0].contact.last_name)
                  "
                  matTooltipPosition="above"
                  class="symbol symbol-30 symbol-circle symbol-light-info"
                >
                  <span
                    [ngStyle]="
                      symbolCSS(
                        getTip(facilities[0].contact.first_name, facilities[0].contact.last_name)
                      )
                    "
                    class="symbol-label font-weight-bold"
                  >
                    {{ facilities[0].contact.first_name[0] | uppercase
                    }}{{ facilities[0].contact.last_name[0] | uppercase }}
                  </span>
                </div>
                <div
                  *ngIf="facilities.length > 1"
                  class="symbol symbol-30 symbol-circle symbol-light-primary"
                >
                  <span
                    [matTooltip]="getFullNameList(facilities)"
                    matTooltipPosition="above"
                    class="symbol-label font-weight-bold"
                    >{{ facilities.length - 1 }}+</span
                  >
                </div>
              </div>
            </ng-container>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchContact">
          <mat-header-cell *matHeaderCellDef class="contact">
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FACILITY.CONTACTS' | translate }}</mat-label>
              <input matInput #searchContactInput (input)="handleContactInput($event)" />
              <mat-select
                #searchContactSelect
                multiple
                style="width: 0 !important"
                (closed)="handleContactClose()"
              >
                <mat-option *ngFor="let contact of contacts$ | async" [value]="contact"
                  >{{ contact.first_name }} {{ contact.last_name }}</mat-option
                >
              </mat-select>
              <button
                class="close-contact-button"
                *ngIf="searchContactSelect.value?.length > 0"
                matSuffix
                mat-icon-button
                (click)="emptyContacts()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="filledByRobot">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FACILITY.BY_ROBOT' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let facility" class="d-flex flex-center">
            <span
              *ngIf="facility.filled_by_robot"
              [matTooltip]="'FACILITY.FILLED_BY_ROBOT' | translate"
              class="svg-icon svg-icon-md"
            >
              <span inlineSVG="assets/media/svg/icons/General/robot-arm.svg"></span>
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchFilledByRobot">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FACILITY.FILLED_BY_ROBOT' | translate }}</mat-label>
              <mat-select
                [(value)]="searchFilledByRobotSelect"
                [placeholder]="'FACILITY.FILLED_BY_ROBOT' | translate"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Filled</mat-option>
                <mat-option value="false">Not Filled</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FACILITY.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(facility.is_active.toString())
              }} label-inline text-center"
            >
              {{ getItemStatusString(facility.is_active.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FACILITY.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'FACILITY.STATUS' | translate"
                (selectionChange)="handleStatusChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            <ng-template ngxPermissionsOnly="canViewFacility">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Facility"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewFacility(facility)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditFacility">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Facility"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editFacility(facility)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivateFacility">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Facility"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateStatusForFacility(facility)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteFacility">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Facility"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteFacility(facility)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
